import React from "react"

// Handles open and close for mobile menu

const ButtonMobileMenu = props => {
  return (
    <button
      className={
        props.mobileNavIsOpen ? "button-mobile-menu open" : "button-mobile-menu"
      }
      onClick={() => props.onClick()}
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  )
}

export default ButtonMobileMenu
